import {
  cloneElement,
  ReactElement,
  useCallback,
  useRef,
  useState,
} from 'react'

export type MouseDraggableAreaProps = {
  children: ReactElement
}
// прокрутка области по перетаскиванию
export function MouseDraggableArea({ children }: MouseDraggableAreaProps) {
  const [isMouseDown, setIsMouseDown] = useState(false)
  const ref = useRef<null | HTMLDivElement>(null)
  const mouseCoords = useRef({
    startX: 0,
    startY: 0,
    scrollLeft: 0,
    scrollTop: 0,
  })

  const handleDragStart = useCallback(
    (e: MouseEvent) => {
      if (!ref.current) return
      const slider = ref.current
      const startX = e.pageX - slider.offsetLeft
      const startY = e.pageY - slider.offsetTop
      const { scrollLeft, scrollTop } = slider

      mouseCoords.current = {
        startX,
        startY,
        scrollLeft,
        scrollTop,
      }
      setIsMouseDown(true)
    },
    [setIsMouseDown, ref],
  )
  const handleDragEnd = useCallback(() => {
    setIsMouseDown(false)
  }, [setIsMouseDown])
  const handleDrag = useCallback(
    (e: MouseEvent) => {
      if (!isMouseDown || !ref.current) return
      e.preventDefault()
      const slider = ref.current
      const x = e.pageX - slider.offsetLeft
      const y = e.pageY - slider.offsetTop
      const walkX = (x - mouseCoords.current.startX) * 1.5
      const walkY = (y - mouseCoords.current.startY) * 1.5
      slider.scrollLeft = mouseCoords.current.scrollLeft - walkX
      slider.scrollTop = mouseCoords.current.scrollTop - walkY
    },
    [isMouseDown, ref],
  )

  const childWithRef = cloneElement(children, {
    ref,
    onMouseDown: handleDragStart,
    onMouseMove: handleDrag,
    onMouseUp: handleDragEnd,
    onMouseLeave: handleDragEnd,
  })

  return childWithRef
}
